import { $elementChild } from "@grindex-common/helpers/elements";
import { apiConfig } from "@grindex-common/helpers/apiConfig";

const HIDDEN_CLASS = "hidden";

function init([$view]) {
	const $stepOne = $elementChild($view, "language-step-one");
	const $stepTwo = $elementChild($view, "language-step-two");
	const $back = $elementChild($view, "language-back");
	const $noResult = $elementChild($view, "language-no-result");
	const $languageForm = $elementChild($view, "language-form");
	const $errorMessage = $elementChild($view, "language-error");
	const $countryLinks = $elementChild($view, "language-country-links");
	const $languageSection = $elementChild($view, "language-section");
	const $languageSelect = $elementChild($view, "language-select");
	const $countrySelect = $view.querySelector("#countrylink");
	const $trigger = document.getElementsByClassName("country-selector-trigger")[0];

	async function renderStepTwo({ CountryLinks: countryLinks, CountryName: countryName }) {
		$stepTwo.classList.remove(HIDDEN_CLASS);
		$stepOne.classList.add(HIDDEN_CLASS);
		$countryLinks.innerHTML = "";

		const $title = document.createElement("h3");
		$title.innerText = countryName;
		$countryLinks.append($title);

		const $list = document.createElement("ul");
		countryLinks.forEach(({ LinkUrl: href, Text: text, NewWindow: targetBlank }) => {
			const $link = document.createElement("a");
			$link.href = href;
			$link.innerText = text;
			$link.title = text;
			$link.target = targetBlank ? "_blank" : "_self";

			const $item = document.createElement("li");
			$item.append($link);
			$list.append($item);
		});
		$countryLinks.append($list);
	}

	async function renderLanguage(countryLink) {
		$languageSection.classList.add(HIDDEN_CLASS);
		$languageSelect.querySelectorAll("option").forEach(($option) => {
			if ($option.value !== "0") {
				$option.remove();
			}
		});

		try {
			const res = await fetch(`/core/countryselector/getlanguagelinks/?countrylink=${countryLink}`);
			const data = await res.json();

			if (data.LanguageLinks && data.LanguageLinks.length > 0) {
				$languageSection.classList.remove(HIDDEN_CLASS);
				data.LanguageLinks.forEach(({ Text: text, LinkUrl: value }) => {
					const $option = document.createElement("option");
					$option.value = value;
					$option.innerText = text;
					$languageSelect.append($option);
				});
			}
		} catch (e) {
			console.warn(e);
		}
	}

	async function GetCountryLinks(countryId) {
		if ($languageSelect) {
			if ($languageSelect.value !== "0") {
				return (window.location.href = $languageSelect.value);
			}
		}

		try {
			const res = await fetch(`/Core/CountrySelector/GetCountryLinks/?countrylink=${countryId}&currentpageId=${apiConfig.apiNode}`);
			const data = await res.json();
			const isOneItem = data.CountryLinks.length === 1;
			const countryLink = isOneItem ? data.CountryLinks[0] : null;

			if (isOneItem && countryLink.NewWindow === true) {
				window.open(countryLink.LinkUrl);
			} else if (isOneItem && $trigger && $trigger.dataset.preserveLocation === "True") {
				var endUrl = window.location.pathname.slice(apiConfig.apiLanguage.length + 2);
				if (data.IsPageAvailableInCurrentCulture) {
					window.location.href = countryLink.LinkUrl.endsWith(endUrl) ? countryLink.LinkUrl : countryLink.LinkUrl + endUrl;
				} else {
					window.location.href = countryLink.LinkUrl;
				}
			} else if (isOneItem) {
				window.location.href = countryLink.LinkUrl;
			} else if (data.CountryLinks.length > 0) {
				renderStepTwo(data);
			} else {
				$stepTwo.classList.remove(HIDDEN_CLASS);
				$stepOne.classList.add(HIDDEN_CLASS);
				$noResult.style.display = "block";
			}
		} catch (e) {
			$errorMessage.style.display = "block";
		}
	}

	if ($languageForm) {
		$languageForm.addEventListener("submit", async (event) => {
			event.preventDefault();
			GetCountryLinks($countrySelect.value);
		});
	}

	if ($back) {
		$back.addEventListener("click", () => {
			$stepTwo.classList.add(HIDDEN_CLASS);
			$stepOne.classList.remove(HIDDEN_CLASS);
			$noResult.style.display = "none";
		});
	}

	if ($countrySelect) {
		$countrySelect.addEventListener("change", async () => {
			renderLanguage($countrySelect.value);
		});

		if ($countrySelect.value) {
			renderLanguage($countrySelect.value);
		}
	}
}

export default {
	view: "country-selector",
	init,
};
